/**
 * 리포트 설정 Store
 *
 * @since 2018-08-16
 * @author Nanhyoung.Ro <dev014>
 */
import {i18n} from '../../../plugins/i18n'

export const state = () => ({
  apiPreFix: '/api/lr/report/',
  settingsApi: 'config',
  autoSendApi: 'servers',
  reportCreate: 'start',
  // ===  onSearch ===
  settingsInfo: {},
  autoSendList: [],
  profileInfos: [{label: 'Default', value: 1}],
  instantReportData: {
    create_req_id: '', // 즉석 리포트 생성 중 폴링 ID
    strActionBtn: '', // 버튼 라벨 ( 실행 / 중지 )
    timeout: null,
    arrStateData: [] // 즉석 리포트 실행 결과 프롬프트 모델
  },
  errorReportName: '' // 리포트 생성 실패시에 현재 진행중인 리포트 이름을 저장한다.
})

export const mutations = {
  setErrorReportName (state, payload) {
    switch (payload) {
      case 'regular':
        state.errorReportName = i18n.t('lr.reportSettings_title_regularReport') // 정기 리포트
        break
      case 'reservation':
        state.errorReportName = i18n.t('lr.reportSettings_title_reserveReport') // 예약 리포트
        break
      case 'instant':
        state.errorReportName = i18n.t('lr.reportSettings_title_instantReport') // 즉석 리포트
        break
      default:
        break
    }
  }
}
export const actions = {
  // 리포트 설정 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingsApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})

      if (result.code === 'ok') {
        state.settingsInfo = result.result[0]
      } else {
        state.settingsInfo = {}
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.settingsInfo = {}
      return result
    }
  },
  // 리포트 프로파일 조회
  async getProfileInfo ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}profiles`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})

      if (result.code === 'ok') {
        const profileInfos = result.result
        const tmpDatas = []
        _.forEach(profileInfos, (data) => {
          tmpDatas.push({label: data.name, value: data.report_prf_id})
        })

        state.profileInfos = tmpDatas
      } else {
        state.profileInfos = [{label: 'Default', value: 1}]
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.profileInfos = [{label: 'Default', value: 1}]
      return result
    }
  },
  async setSettingReportInfo ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingsApi}`
    try {
      param.report_save_term = '' + param.report_save_term
      result = await this.$axios.$put(apiUrl, param, {loading: true, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.settingsInfo = {}
      return result
    }
  },
  // 리포트 자동 전송 조회
  async getAutoSendList ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.autoSendApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})

      if (result.code === 'ok') {
        state.defaultSendList = result.result
      } else {
        state.defaultSendList = []
      }
      state.autoSendList = _.cloneDeep(state.defaultSendList)
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.defaultSendList = []
      state.autoSendList = []
      return result
    }
  },
  // 리포트 자동 전송 추가
  async addAutoSendInfo ({state, dispatch}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.autoSendApi}`
    try {
      result = await this.$axios.$post(apiUrl, param)
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 리포트 자동 전송 수정
  async editAutoSendInfo ({commit, state, dispatch}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.autoSendApi}`
    try {
      result = await this.$axios.$put(apiUrl, param, {successAlert: false})
      if (result.code === 'ok') {
        // dispatch('getAutoSendList')
        this.dispatch(`common/common/setIsChanged`, true)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  async removeAutoSendInfo ({commit, state}, svrId) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.autoSendApi}?report_send_server_id=${svrId}`
    try {
      result = await this.$axios.$delete(apiUrl)
      if (result.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        const findIdx = _.findIndex(state.autoSendList, (d) => {
          return d.report_send_server_id === svrId
        })
        state.autoSendList.splice(findIdx, 1)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      return result
    }
  },

  // 즉석리포트 시작 (param = { s_date: '', e_date: '' })
  async startCreateReport ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}instant/${state.reportCreate}`
    try {
      result = await this.$axios.$post(apiUrl, param, {successAlert: false})
      if (result.code === 'ok' || result.code === 'async') {
        state.instantReportData.create_req_id = result.result.request_id
      } else {
        state.instantReportData.create_req_id = ''
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.instantReportData.create_req_id = ''
      return result
    }
  },
  // 즉석리포트 상태 조회
  async getCreateState ({state, dispatch, commit}) {
    if (state.instantReportData.create_req_id === '') {
      return
    }
    let result = {}
    const apiUrl = `${state.apiPreFix}instant/${state.instantReportData.create_req_id}${'/status'}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        // 실패 테스트 코드
        // result.result.status = 'FAIL'
        // result.result.report_type = 'regular'
        // result.result.sub_status = 'Report-Gen already running'

        state.instantReportData.arrStateData = result.result.sub_status.split('\n')

        if (result.result.status === 'FAIL') {
          commit('setErrorReportName', result.result.report_type)
          // end
          dispatch('endCreateReport', 3)
          state.instantReportData.strActionBtn = i18n.t('lr.reportSettings_btn_action')
          return result
        }

        const isNext = state.instantReportData.arrStateData.indexOf('END') < 0 && state.instantReportData.arrStateData.indexOf('FAILURE') < 0
        if (isNext && (state.instantReportData.strActionBtn !== i18n.t('lr.reportSettings_btn_action'))) {
          // IN_PROGRESS
          state.instantReportData.timeout = setTimeout(() => {
            dispatch('getCreateState')
          }, 3000)
        } else if (state.instantReportData.arrStateData.indexOf('END') > -1) {
          // end
          dispatch('endCreateReport', 2)
          state.instantReportData.strActionBtn = i18n.t('lr.reportSettings_btn_action')
        } else { // failure
          dispatch('endCreateReport', i18n.t('lr.reportSettings_msg_createFailure'))
          state.instantReportData.strActionBtn = i18n.t('lr.reportSettings_btn_action')
        }
      } else {
        dispatch('endCreateReport', result.result.msg)
        state.instantReportData.strActionBtn = i18n.t('lr.reportSettings_btn_action')
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      return result
    }
  },
  // 즉석리포트 생성 중지
  async stopCreateReport ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}instant/${state.instantReportData.create_req_id}${'/stop'}`
    try {
      result = await this.$axios.$delete(apiUrl, {successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      return result
    }
  },
  // 즉석리포트 생성 끝
  // param => 1: 로딩창 true, 2: 로딩창 false, 3: 생성 실패 팝업 & 로딩창 false
  async endCreateReport ({commit, state, rootState}, param) {
    let loading = false
    if (param === 1) {
      loading = true
    }
    let result = {}
    const apiUrl = `${state.apiPreFix}instant/${state.instantReportData.create_req_id}${'/end'}`
    try {
      result = await this.$axios.$delete(apiUrl, {loading: loading, successAlert: false})
      if (result.code === 'ok') {
        state.instantReportData.create_req_id = ''
        if (param === 2) {
          rootState.common.common.components.alertDialog.show(i18n.t('msg.reportSettings_instanceReportComplete'))
        } else if (param === 3) {
          rootState.common.common.components.alertDialog.show(i18n.t('msg.reportSettings_reportAlreadyRunning', {name: state.errorReportName}))
        } else if (typeof param === 'string') {
          rootState.common.common.components.alertDialog.show(param)
        }
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },

  async applySettings ({commit, state}, chgData) {
    let result = {}
    const apiUrl = `${state.apiPreFix}config/apply`
    try {
      chgData.report_save_term = '' + chgData.report_save_term
      result = await this.$axios.$put(apiUrl, chgData, {applyMsg: true})
      if (result.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, false)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.settingsInfo = {}
      return result
    }
  },
  async cancelSettings ({state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}config/cancel`
    try {
      result = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
      if (result.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, false)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.msg = e
      state.settingsInfo = {}
      return result
    }
  }
}

export const getters = {}

export const strict = false
